import { ListItem, styled } from '@mui/material';

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  width: '100%',
  padding: 0,
  overflow: 'hidden',
  gap: 0,

  [theme.breakpoints.up('sm')]: {
    gap: 2,
  },
}));
